import { Avatar } from '@chakra-ui/react';
import { useAuthInfo } from '@propelauth/react';

export default function UserAvatar() {
  const { user } = useAuthInfo();
  return <Avatar bg="#EFEFF3" boxSize={'36px'} name={user?.firstName} src={user?.pictureUrl || ''} />;
}
